import React from "react";
import "./Sidebar.css";
import FinancialPlanningSvg from "../resources/tip-jar.svg";
import MutualFundsSvg from "../resources/pig-money.svg";
import LifeInsuranceSvg from "../resources/heartbeat.svg";
import GeneralInsuranceSvg from "../resources/user-shield.svg";
import EstatePlanningSvg from "../resources/home-dollar.svg";
import TaxPlanningSvg from "../resources/transaction-rupee.svg";
import EducationPlanningSvg from "../resources/books.svg";
import RetirementSuperannuationSvg from "../resources/old.svg";
import ResearchDevelopmentSvg from "../resources/microscope.svg";
import ChildMarriagePlanningSvg from "../resources/marriage.svg";
import { NavLink } from "react-router-dom";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <aside className={`services-sidebar ${isSidebarOpen ? "open" : "closed"}`}>
      <div className="services-logo">
        <h3 className="heading">Our Services</h3>
      </div>
      <button
        aria-label="toggle"
        type="button"
        className={`services-menu-toggle ${isSidebarOpen ? "open" : "closed"}`}
        onClick={toggleSidebar}
      >
        <span
          className={`services-menu-icon ${isSidebarOpen ? "open" : "closed"}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon-tabler icons-tabler-outline icon-tabler-chevron-left"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M15 6l-6 6l6 6" />
          </svg>
        </span>
      </button>

      <div className="services-sidebar-content">
        <ul className="services-lists">
          <li className="services-list">
            <NavLink
              to="/services/future-freedom-planning"
              className={`services-nav-link ${isSidebarOpen ? "open" : "closed"}`}
              onClick={closeSidebar}
            >
              <img
                className="services-icon"
                alt=""
                src={FinancialPlanningSvg}
              />
              <span className="services-link">Future Freedom Planning</span>
            </NavLink>
          </li>
          <li className="services-list">
            <NavLink
              to="/services/mutual-funds"
              className={`services-nav-link ${isSidebarOpen ? "open" : "closed"}`}
              onClick={closeSidebar}
            >
              <img className="services-icon" alt="" src={MutualFundsSvg} />
              <span className="services-link">Mutual Funds</span>
            </NavLink>
          </li>
          {/* <li className="services-list"> */}
          {/*     <NavLink */}
          {/*         to="/services/life-insurance" */}
          {/*         className={`services-nav-link ${isSidebarOpen ? 'open' : 'closed'}`} */}
          {/*         onClick={closeSidebar} */}
          {/*     > */}
          {/*         <img className='services-icon' alt="" src={LifeInsuranceSvg} /> */}
          {/*         <span className="services-link">Life Insurance</span> */}
          {/*     </NavLink> */}
          {/* </li> */}
          {/* <li className="services-list"> */}
          {/*     <NavLink */}
          {/*         to="/services/general-insurance" */}
          {/*         className={`services-nav-link ${isSidebarOpen ? 'open' : 'closed'}`} */}
          {/*         onClick={closeSidebar} */}
          {/*     > */}
          {/*         <img className='services-icon' alt="" src={GeneralInsuranceSvg} /> */}
          {/*         <span className="services-link">General Insurance</span> */}
          {/*     </NavLink> */}
          {/* </li> */}
          <li className="services-list">
            <NavLink
              to="/services/estate-guidance"
              className={`services-nav-link ${isSidebarOpen ? "open" : "closed"}`}
              onClick={closeSidebar}
            >
              <img className="services-icon" alt="" src={EstatePlanningSvg} />
              <span className="services-link">Estate Guidance</span>
            </NavLink>
          </li>
          <li className="services-list">
            <NavLink
              to="/services/tax-guidance"
              className={`services-nav-link ${isSidebarOpen ? "open" : "closed"}`}
              onClick={closeSidebar}
            >
              <img className="services-icon" alt="" src={TaxPlanningSvg} />
              <span className="services-link">Tax Guidance</span>
            </NavLink>
          </li>
          {/* <li className="services-list"> */}
          {/*     <NavLink */}
          {/*         to="/services/education-guidance" */}
          {/*         className={`services-nav-link ${isSidebarOpen ? 'open' : 'closed'}`} */}
          {/*         onClick={closeSidebar} */}
          {/*     > */}
          {/*         <img className='services-icon' alt="" src={EducationPlanningSvg} /> */}
          {/*         <span className="services-link">Education Guidance</span> */}
          {/*     </NavLink> */}
          {/* </li> */}
          {/* <li className="services-list"> */}
          {/*     <NavLink */}
          {/*         to="/services/retirement-superannuation" */}
          {/*         className={`services-nav-link ${isSidebarOpen ? 'open' : 'closed'}`} */}
          {/*         onClick={closeSidebar} */}
          {/*     > */}
          {/*         <img className='services-icon' alt="" src={RetirementSuperannuationSvg} /> */}
          {/*         <span className="services-link">Retirement & Superannuation</span> */}
          {/*     </NavLink> */}
          {/* </li> */}
          {/* <li className="services-list"> */}
          {/*     <NavLink */}
          {/*         to="/services/research-development" */}
          {/*         className={`services-nav-link ${isSidebarOpen ? 'open' : 'closed'}`} */}
          {/*         onClick={closeSidebar} */}
          {/*     > */}
          {/*         <img className='services-icon' alt="" src={ResearchDevelopmentSvg} /> */}
          {/*         <span className="services-link">Research & Development</span> */}
          {/*     </NavLink> */}
          {/* </li> */}
          {/* <li className="services-list"> */}
          {/*     <NavLink */}
          {/*         to="/services/child-marriage-guidance" */}
          {/*         className={`services-nav-link ${isSidebarOpen ? 'open' : 'closed'}`} */}
          {/*         onClick={closeSidebar} */}
          {/*     > */}
          {/*         <img className='services-icon' alt="" src={ChildMarriagePlanningSvg} /> */}
          {/*         <span className="services-link">Child Marriage Guidance</span> */}
          {/*     </NavLink> */}
          {/* </li> */}
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
